<template>
  <span>
    <!--<span id="txs_settings"   class="txs_icon" v-on:click="launch_settings()">⚙</span>-->
    <span id="txs_play_pause" class="txs_icon" v-on:click="play_pause">
      <img v-if="paused" src="../assets/play.svg" width="22px" />
      <img v-else        src="../assets/pause.svg" width="22px" />
    </span>

    <span id="clear_txs" class="txs_icon" v-on:click="clear_txs">
      <img src="../assets/trash.svg" width="22px" />
    </span>
  </span>
</template>

<script>
export default {
  name: 'TxsControl',

  computed : {
    paused : function(){
      return this.$store.state.paused_txs;
    }
  },

  methods : {
    launch_settings : function(){
    },

    play_pause : function(){
      this.$store.commit('toggle_paused_txs');
    },

    clear_txs : function(){
      this.$store.commit('clear_txs');
    }
  }
}
</script>

<style scoped>
#txs_settings{
  vertical-align: middle;
}

.txs_icon {
  margin: 2px;
  padding: 2px;
  border-radius: 15px;
  cursor: pointer;
}

img{
  opacity: 0.4;
}
</style>
